import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_blue_square.svg';
import Icon, { IconProps } from './icon';

const IconBlueSquare = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconBlueSquare;
